import { useRef, useState } from "react";
import { Form, Input, Modal, message } from "antd";
import { addShopOrderRemark } from "@/api/shopOrder";
import type { ShopOrderRemarkInput, ShopOrderRow } from "@/api/shopOrder";
import { ProductImageInput } from "../product/ProductImageInput";

interface OrderRemarkModalProps {
  row: ShopOrderRow;
  onCancel: () => void;
  onSuccess: () => void;
}
export function OrderRemarkModal({ row, onCancel, onSuccess }: OrderRemarkModalProps): React.ReactElement {
  const [form] = Form.useForm<ShopOrderRemarkInput>();
  const [uploading, setUploading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const pending = useRef(false);
  const handleSubmit = async (): Promise<void> => {
    if (uploading || pending.current) return;
    pending.current = true;
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await addShopOrderRemark({ orderId: row.id, remarkContent: values.remarkContent.trim(),
        ...(values.image?.trim() ? { image: values.image.trim() } : {}) });
      void message.success("备注添加成功");
      onSuccess();
    } catch {
      // 表单及请求层展示错误，保留输入以便重试。
    } finally {
      pending.current = false;
      setSubmitting(false);
    }
  };
  const handleCancel = (): void => { if (!uploading && !pending.current) onCancel(); };
  return <Modal open title="添加订单备注" onCancel={handleCancel} onOk={handleSubmit}
    okText="保存" cancelText="取消" confirmLoading={submitting} okButtonProps={{ disabled: uploading }}
    cancelButtonProps={{ disabled: uploading || submitting }} closable={!uploading && !submitting}
    keyboard={!uploading && !submitting} maskClosable={false}>
    <Form form={form} layout="vertical" disabled={submitting}>
      <Form.Item label="订单号">{row.orderNo}</Form.Item>
      <Form.Item name="remarkContent" label="备注内容" rules={[
        { required: true, whitespace: true, message: "请输入备注内容" },
        { max: 500, message: "备注内容最多500字" },
      ]}>
        <Input.TextArea rows={4} maxLength={500} showCount placeholder="请输入备注内容" />
      </Form.Item>
      <Form.Item name="image" label="备注图片（选填）" rules={[{ max: 255, message: "图片地址最多255字" }]}>
        <ProductImageInput disabled={submitting} onBusyChange={setUploading} />
      </Form.Item>
    </Form>
  </Modal>;
}
